import React from 'react';
import WarnIcon from '../../../../common/icons/warn.svg';
import LoaderIcon from '../../../../common/icons/loader-animation-portal.svg';

import './index.scss';

class PreloaderWidget extends React.Component {
    render() {
        const { icon, message } = this.props;

        const iconGraphic =
            icon === 'spinner' ? <LoaderIcon /> : icon === 'exclamation' ? <WarnIcon /> : null;

        return (
            <div className="opl-widget-preloader">
                {iconGraphic && <div className="opl-widget-preloader--icon">{iconGraphic}</div>}
                {message && (
                    <div className="opl-widget-preloader--message">
                        <p>{message}</p>
                    </div>
                )}
            </div>
        );
    }
}

export default PreloaderWidget;
